import {useLocalStorage} from '@rehooks/local-storage';
import {LocalStorageKeys} from '../common/types';
import {hasLocalStorageFlag} from '../common/localStorageFlags';
import {ANDROID_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY} from '../common/android';
import {IOS_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY} from '../common/ios';

export const useIsRieltorApp = () => {
  const [isRieltorApp] = useLocalStorage(LocalStorageKeys.IsRieltorApp);

  return !!isRieltorApp || hasLocalStorageFlag(IOS_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY);
};

export const useIsAndroidRieltorApp = () => {
  //useragent with app_rieltor_dashboard

  return /app_rieltor_dashboard/.test(navigator.userAgent) ||
    hasLocalStorageFlag(ANDROID_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY);
}
